import React from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconCalendar = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconCalendar.dimensions.width} ${IconCalendar.dimensions.height}`}
      {...otherProps}
    >
      <G
        stroke={color || Color.premiumBlack}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.6}
        fill="none"
      >
        <Path
          d="M2.75 4.834c0-.645.522-1.167 1.167-1.167h14.166c.645 0 1.167.522 1.167 1.167V19c0 .645-.522 1.167-1.167 1.167H3.917A1.167 1.167 0 0 1 2.75 19V4.834Z"
          clipRule="evenodd"
        />
        <Path d="M14.666 1.833V5.5M7.334 1.833V5.5M2.75 9.167h16.5" />
      </G>
    </Svg>
  )
}

IconCalendar.dimensions = {
  width: 22,
  height: 22,
}

export default IconCalendar
